import React from 'react';

/**
 * AffectedRecipesNotice
 * Shows a contextual inline card using the shared "info-card" styling from MachineRecipes.css
 */
const AffectedRecipesNotice = ({ oldIngredientName, newIngredientName, recipes = [] }) => {
	if (!recipes || recipes.length === 0) return null;

	return (
		<div className="info-card mb-3 p-2 md:p-3">
			<div className="info-content">
				<div className="info-icon-wrapper">
					<i className="pi pi-exclamation-triangle info-icon"></i>
				</div>
				<div className="info-text">
					<span className="info-title text-xs md:text-sm">
						Changing {oldIngredientName} to {newIngredientName} will affect:
					</span>
					<ul className="m-0 pl-3 mt-2">
						{recipes.map((recipe) => (
							<li className="text-xs md:text-sm" key={recipe.id}>
								{recipe.name}
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default AffectedRecipesNotice;
